// Angular Import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// third party
import 'hammerjs';
import 'mousetrap';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
// bootstrap import
import {
  NgbDropdownModule,
  NgbNavModule,
  NgbModule,
  NgbCollapseModule,
  NgbProgressbar,
  NgbProgressbarModule
} from '@ng-bootstrap/ng-bootstrap';



import { FixedNavbarComponent } from './components/fixed-navbar/fixed-navbar.component';
import { LeftNavbarComponent } from './components/left-navbar/left-navbar/left-navbar.component';
import { BreadcrumbModule } from './components/breadcrumb/breadcrumb.module';

@NgModule({

  declarations: [SpinnerComponent, LeftNavbarComponent],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbModule,
    NgbCollapseModule,
    NgScrollbarModule,
    NgbProgressbarModule,
    NgbProgressbar,
    BreadcrumbModule

  ],
  exports: [
    CommonModule,
    // DataFilterPipe,
    FormsModule,
    ReactiveFormsModule,
    // CardModule,
    BreadcrumbModule,
    NgbModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbCollapseModule,
    NgScrollbarModule,
    NgbProgressbar,
    NgbProgressbarModule,
    // TodoListRemoveDirective,
    // TodoCardCompleteDirective,
    // ModalModule,
    // AlertModule,
    // GalleryModule,
    SpinnerComponent
  ]
})
export class SharedModule { }